import React from 'react';
import { formatDisplayDate } from '@/utils/dateHelpers';
import { FaCheckCircle, FaTimesCircle, FaCircle } from 'react-icons/fa';
import {
  Step,
  StepLabel,
  Stepper,
  StepConnector,
  StepContent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  DonationTrackerEventLabels,
  DonationTrackerEventStatus,
  DonationTrackerTypes,
} from '@/constants/donationTracker.constant';
import getQualifiedImageUrl from '@/utils/imageUrlProcessor';
import { last } from 'lodash-es';

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    borderLeftColor: '#F0F2F5',
    borderLeftWidth: 4,
  },

  '&.Mui-active .MuiStepConnector-line': {
    borderLeftWidth: 4,
    borderLeftColor: '#33CCCC',
  },
  '&.Mui-completed .MuiStepConnector-line': {
    borderLeftWidth: 4,
    borderLeftColor: '#33CCCC',
  },
}));

const stepStyle = {
  // boxShadow: 2,
  // backgroundColor: 'rgba(0, 0, 0, 0.1)',
  // padding: 2,
  '& .MuiStepConnector-line': {
    borderLeftWidth: 3, // Ensure consistent width across all states
    borderColor: '#F0F2F5', // Default color for the connector line
  },
  '& .Mui-active': {
    '&.MuiStepIcons-root': {
      // color: ''
    },
    '& .MuiStepConnector-line': {
      borderColor: '#33CCCC',
    },
  },
  '& .Mui-completed': {
    '&.MuiStepIcons-root': {
      // color: ''
    },
    '& .MuiStepConnector-line': {
      borderColor: '#33CCCC',
    },
  },
};

const statusIcons = {
  completed: 'text-primary',
  failed: 'text-red-500',
  pending: 'text-gray-200',
  default: 'text-gray-200',
};

const renderStepIcon = (status, isLastStep) => {
  // if (isLastStep) {
  //   <img
  //     src={getQualifiedImageUrl(nonProfit.logo_url)}
  //     alt="nonprofit-log0"
  //     className={`h-7 w-7`}
  //   />;
  // }

  const eventStatus = DonationTrackerEventStatus[status];
  switch (eventStatus) {
    case 'completed':
      return (
        <FaCheckCircle className={`h-7 w-7 ${statusIcons[eventStatus]}`} />
      );
    case 'failed':
      return (
        <FaTimesCircle className={`h-7 w-7 ${statusIcons[eventStatus]}`} />
      );
    default:
      return <FaCircle className={`h-7 w-7 ${statusIcons['default']}`} />;
  }
};

const ContributionTrackerVerticalStepper = (props) => {
  const { tracker, company, fundraisingOrg } = props;

  const trackerType = tracker.type;
  const trackerLabels = DonationTrackerEventLabels[trackerType].labels;
  const trackerEvents = tracker.events;

  const steps = trackerLabels.map((label) => {
    const event = trackerEvents.find((e) => e.eventId === label.id);

    let title = label.label
      .replace(/\[Company Name\]/g, company?.name)
      .replace(/\[FundraisingOrg Name\]/g, fundraisingOrg?.name);

    if (event) {
      return {
        date: event.date,
        status: event.status,
        label: title,
        connectorColor: '#33CCCC',
      };
    }

    return {
      date: null,
      status: 2,
      label: title,
      connectorColor: '#F0F2F5',
    };
  });

  const activeStep = last(trackerEvents);

  return (
    <div className="mx-auto">
      <Stepper
        // activeStep={activeStep}
        orientation="vertical"
        sx={stepStyle}>
        {steps.map((step, index) => (
          <Step key={index} completed={step.status === 1}>
            <StepLabel
              icon={renderStepIcon(
                step.status,
                trackerLabels.length === index + 1,
              )}
              className="p-0">
              <div className={`font-normal`}>{step.label}</div>
              {step.date && step.status !== 2 && (
                <div className="text-12 text-gray-400">
                  {formatDisplayDate(step.date)}
                </div>
              )}
            </StepLabel>
            {/* <StepContent>
              {step.date && (
                <div className="text-12 text-gray-400">
                  {formatDisplayDate(step.date)}
                </div>
              )}
            </StepContent> */}
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default ContributionTrackerVerticalStepper;
